<template>
  <div class="new-connection">
    <div class="title">{{ $tr('vacancy.videoInterview.connections.new') }}</div>
    <div class="form">
      <multiselect
        class="group"
        v-model="group"
        :options="groups"
        label="name"
        track-by="id"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
        />
      <multiselect
        class="question"
        v-model="question"
        :options="questions"
        label="label"
        track-by="id"
        :searchable="true"
        :allow-empty="false"
        :show-labels="false"
        />
      <vbutton
        class="button"
        label="actions.add"
        :disabled="!validate"
        @click="add"/>
    </div>
  </div>
</template>
<script>
  import {createNamespacedHelpers} from 'vuex';

  const {mapGetters, mapMutations} = createNamespacedHelpers('vacancy_new/video_interview_groups');

  export default {
    name: 'new-connection',
    data() {
      return {
        group: null,
        question: null
      }
    },
    computed: {
      ...mapGetters({
        groups: 'groups',
        questions: 'questions_without_group'
      }),
      validate() {
        return this.group && this.question;
      },
      connection() {
        return {
          group_id: +this.group.id,
          question_id: +this.question.id
        };
      }
    },
    methods: {
      ...mapMutations({
        add_connection: 'add_connection'
      }),
      add() {
        this.add_connection(this.connection);
        this.question = null;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .new-connection {
    .title {
      margin: 5px 0;
      font-weight: 700;
    }
    .form {
      display: flex;
      align-items: center;
      margin: 5px 0;
      .group {
        margin-right: 20px;
        width: 190px;
        min-width: 190px;
      }
      .question {
        margin-right: 20px;
        max-width: 300px;
      }
      .button {
        margin: 0;
      }
    }
  }
</style>